exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paypal-container[data-v-164e36f0] {\n  width: 100%;\n}\n.paypal-container h4[data-v-164e36f0] {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n@media screen and (max-width: 576px) {\n.paypal-container[data-v-164e36f0] {\n    padding: 2rem 0;\n}\n.paypal-container .paypal-checkout-button[data-v-164e36f0] {\n    width: 100%;\n}\n}\n@media screen and (min-width: 576px) {\n.paypal-container[data-v-164e36f0] {\n    padding: 2rem 0;\n}\n.paypal-container .paypal-checkout-button[data-v-164e36f0] {\n    width: 400px;\n    margin: 0 auto;\n    padding-bottom: 10px;\n}\n}", ""]);

// exports
